"use client";

import styles from "@/styles/home/category-grid.module.scss";
import Image from "next/image";

interface CategoryItem {
  title: string;
  href: string;
  image: string;
}

export default function CategoryGrid() {
  const categoryList: CategoryItem[] = [
    {
      title: "Holiday Deals",
      href: "/holiday-deals/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-2975.svg",
    },
    {
      title: "Appliances",
      href: "/appliances/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-2107.svg",
    },
    {
      title: "Furniture",
      href: "/furniture/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-57.svg",
    },
    {
      title: "Home & Garden",
      href: "/home-garden/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-147.svg",
    },
    {
      title: "Sports & Fitness",
      href: "/sports-fitness/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-4.svg",
    },
    {
      title: "Pet Supplies",
      href: "/pet-supplies/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-73.svg",
    },
    {
      title: "Baby, Kids & Toys",
      href: "/baby-kids-toys/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-2959.svg",
    },
    {
      title: "Outdoor & Leisure",
      href: "/outdoor-leisure/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-334.svg",
    },
    {
      title: "Tools & Auto",
      href: "/tools-auto/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-2957.svg",
    },
    {
      title: "Bedding & Bath",
      href: "/bedding-bath/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-258.svg",
    },
    {
      title: "Health & Beauty",
      href: "/health-beauty/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-62.svg",
    },
    {
      title: "Electronics",
      href: "/electronics/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-50.svg",
    },
    {
      title: "Novelties & Gifts",
      href: "/novelties-gifts/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-65.svg",
    },
    {
      title: "Musical Instruments",
      href: "/musical-instruments/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-35.svg",
    },
    {
      title: "Jewellery",
      href: "/jewellery/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-991.svg",
    },
    {
      title: "LED Lights",
      href: "/led-lights/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-3781.svg",
    },
    {
      title: "Fashion & Bags",
      href: "/fashion-bags/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-109.svg",
    },
    {
      title: "Computers & IT",
      href: "/computers-it/",
      image: "//img.crazysales.com.au/images/newhomepage/mobile/svg/category/icon-category-70.svg",
    },
  ];
  const handleViewDetail = (cate: CategoryItem) => {
    if (!cate.href) return;
    window.location.href = `/category${cate.href}`;
  };

  return (
    <div className={styles["comp-category-grid"]}>
      <div className={styles["category-grid-list"]}>
        {categoryList.map((cate: CategoryItem, index: number) => (
          <div className={styles["category-grid-item"]} key={cate.title}>
            <Image
              className={styles["category-icon"]}
              src={cate.image}
              alt={cate.title}
              width={44}
              height={44}
              priority={index < 5 ? true : false}
              onClick={() =>
                handleViewDetail(cate)
              }
            />

            <div className={styles["category-name"]}>{cate.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
